import * as React from 'react'
import Box from '@mui/material/Box'
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined'
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined'
import { useTranslation } from 'react-i18next'

import AddParticipantsDialog from 'components/Participants/AddParticipants/AddParticipantsDialog'
import ImportParticipantDialog from 'components/Participants/AddParticipants/ImportUsersDialog'
import PRMActionButtons from 'components/Shared/PRMActionButtons'
import { handleDialogueSelection } from 'components/Participants/AddParticipants/Helper'

type Options = 'invite' | 'import'

const options: Options[] = ['invite', 'import']

const InviteParticipant = () => {
  const [open, setOpen] = React.useState(false)
  const [currentDialogue, setDialogue] = React.useState('')
  const anchorRef = React.useRef<HTMLDivElement>(null)

  const { t } = useTranslation()

  const handleMenuItemClick = (option: Options) => {
    handleDialogueSelection(option, setDialogue)
    setOpen(false)
  }

  const handleToggle = () => setOpen((prevOpen) => !prevOpen)

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }

    setOpen(false)
  }

  const InviteParticipantIcon = (
    <MailOutlineOutlinedIcon
      fontSize="small"
      sx={{ mr: 2 }}
      data-testid={'invite-option'}
    />
  )

  const ImportParticipantIcon = (
    <CloudUploadOutlinedIcon
      fontSize="small"
      sx={{ mr: 2 }}
      data-testid={'import-option'}
    />
  )

  return (
    <Box>
      <PRMActionButtons
        handleToggle={handleToggle}
        anchorRef={anchorRef}
        open={open}
        label={t('participant.inviteAdmin.buttonText')}
        options={options}
        handleMenuItemClick={handleMenuItemClick}
        handleClose={handleClose}
        optionIcons={[InviteParticipantIcon, ImportParticipantIcon]}
        buttonGroupId={'add-participant'}
        page={'PRMGrid'}
      />
      <AddParticipantsDialog
        isOpen={currentDialogue === 'invite'}
        handleCancel={() => setDialogue('')}
      />
      {currentDialogue === 'import' && (
        <ImportParticipantDialog
          isOpen={true}
          handleCancel={() => setDialogue('')}
        />
      )}
    </Box>
  )
}

export default InviteParticipant
